// Windows 8 mobile Responsive utility
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
	var msViewportStyle = document.createElement('style')
	msViewportStyle.appendChild(document.createTextNode('@-ms-viewport{width:auto!important}'))
	document.querySelector('head').appendChild(msViewportStyle)
}

jQuery(document).ready(function () {
	// LazyLoading
	jQuery('img').unveil(500, function () {
		jQuery(this).on('load', function () {
			jQuery(this).removeAttr('data-src')
		})
	})
	jQuery('.fancybox2').fancybox({
		type: 'iframe',
		iframe: {
			css: {
				width: '850px',
			},
		},
		smallBtn: true,
		buttons: [],
		afterShow: function (opts, obj) {
			$('<button data-fancybox-close="" class="fancybox-close--down" title="Zavřít">Zavřít</button>').insertAfter('iframe')
		},
	})
	jQuery('.fancybox3').fancybox({
		type: 'iframe',
		baseClass: 'popup-mobile-fancy',
		iframe: {
			css: {
				width: '480px',
			},
		},
		smallBtn: false,
		buttons: false,
		afterShow: function (opts, obj) {
			$('<button data-fancybox-close="" class="btn btn--close btnCloseModal" title="Zavřít">&times;</button>').insertAfter('iframe')
		},
	})

	Fancybox.bind('[data-fancybox="trigger-cookies-popup-1"]', {
		closeButton: false,
		dragToClose: false,
		click: false,
		mainClass: 'cookie-bar',
		keyboard: false,
	})

	Fancybox.bind('[data-fancybox="trigger-cookies-popup-2"]', {
		closeButton: false,
		dragToClose: false,
		click: true,
		mainClass: 'cookie-bar',
		keyboard: false,
	})

	Fancybox.bind('[data-fancybox="popup-kontakt"]', {
		closeButton: 'inside',
		mainClass: 'c-popup-block',
	})

	if ($('#subitems-1').is(':checked')) {
		$('.subitems').addClass('d-none')
		$('.subitems-1').removeClass('d-none')
	} else if ($('#subitems-2').is(':checked')) {
		$('.subitems').addClass('d-none')
		$('.subitems-2').removeClass('d-none')
	} else if ($('#subitems-3').is(':checked')) {
		$('.subitems').addClass('d-none')
		$('.subitems-3').removeClass('d-none')
	} else if ($('#subitems-4').is(':checked')) {
		$('.subitems').addClass('d-none')
		$('.subitems-4').removeClass('d-none')
	}
})

$(window).ready(function () {
	setInterval(function () {
		$('.app-down').addClass('app-down--show')
	}, 5000)
})

$('.app-down__close').click(function () {
	$('.app-down').hide()
})

$('#modal-info-close').click(function () {
	$('.modal-info').hide()
})

/* ==========================================================================
    FANCYBOX
  ========================================================================== */

// Fancybox global init
Fancybox.bind('[data-fancybox]')

// Fancybox custom dialog & options
Fancybox.bind('[data-fancybox-prices-dialog]', {
	backdropClick: false,
	on: {
		close: () => {
			console.log('Modal closed')
		},
		destroy: () => {
			smoothScrollingTo('#competition__step-two')
			console.log('Modal destroyed')
		},
		loaded: () => {
			// smoothScrollingTo('#competition__step-two');
			console.log('Modal loaded')
		},
	},
	selector: 'wadwa',
})

/* ==========================================================================
    COOKIE ACTIONS
  ========================================================================== */

$('#cookie-bar__setup').hide()

$('#go-to-setup-btn').click(function () {
	$('#cookie-bar__setup').show()
	$('.cookie-bar__content').hide()
})

$('#go-to-content-btn').click(function () {
	$('#cookie-bar__setup').hide()
	$('.cookie-bar__content').show()
})

$('.cookie-bar__setup__close').click(function () {
	$('#cookie-bar__setup').hide()
	$('.cookie-bar__content').show()
})

$('#accept-btn').click(function () {
	parent.jQuery.fancybox.destroy()
})

$('.i-contact__title').click(function () {
	$(this).parent().find('.i-contact__content').toggle()
})

$('.company-slider').bxSlider({
	pager: false,
	video: true,
	nextText: '<img src="images/nextBtn.png" width="29" height="34"/>',
	prevText: '<img src="images/prevBtn.png" width="29" height="34"/>',
})

$('.major-ad__slider').bxSlider({
	pager: false,
	infiniteLoop: false,
	maxSlides: 3,
	slideWidth: 170,
	slideMargin: 10,
	moveSlides: 1,
	hideControlOnEnd: true,
	nextText: '<img src="images/arrow-more.svg" width="60" height="60"/>',
	prevText: '<img class="rotate-me" src="images/arrow-more.svg" width="60" height="60"/>',
})

$('.driving-sentences').bxSlider({
	controls: false,
	auto: $('.driving-sentences .driving-sentences__item').length > 1 ? true : false,
	pager: $('.driving-sentences .driving-sentences__item').length > 1 ? true : false,
	touchEnabled: $('.driving-sentences .driving-sentences__item').length > 1 ? true : false,
	oneToOneTouch: $('.driving-sentences .driving-sentences__item').length > 1 ? true : false,
	infiniteLoop: true,
	maxSlides: 1,
	moveSlides: 1,
	pause: 5000,
})

$('a.scrollLink').click(function (event) {
	event.preventDefault()
	$('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top - 20 }, 1000)
})

// Cookie via jQuery
$('.show-jquery-cookie').click(function () {
	$('.cookie-bar__bg').addClass('cookie-bar__bg--visible')
})

$('#cookie-accept').click(function () {
	$('.cookie-bar__bg').removeClass('cookie-bar__bg--visible')
})

$('#my-reason').val('')

$('#cookie-setup').click(function () {
	$('.cookie-bar__content').hide()
	$('.cookie-bar__setup').show()
})

$('#cookie-agree').click(function () {
	$('.cookie-bar__bg').removeClass('cookie-bar__bg--visible')
	$('.cookie-bar__setup').hide()
	$('.cookie-bar__content').show()
})

$('#cookie-cancel').click(function () {
	$('.cookie-bar__setup').hide()
	$('.cookie-bar__content').show()
})

$('#cookie-close').click(function () {
	$('.cookie-bar__setup').hide()
	$('.cookie-bar__content').show()
})

$.fn.extend({
	toggleText: function (a, b) {
		var that = this
		if (that.text() != a && that.text() != b) {
			that.text(a)
		} else if (that.text() == a) {
			that.text(b)
		} else if (that.text() == b) {
			that.text(a)
		}
		return this
	},
})

$('.c-profile__positions__block').each(function (index) {
	var getItemsCount = $(this).find('.c-profile__list').children().length
	var getMoreBtn = $(this).find('.c-profile__more')

	$(getMoreBtn).click(function () {
		$('.c-profile__list').toggleClass('c-profile__list--full')
		$(this).toggleText('Načíst další', 'Zobrazit méně')
	})

	if (getItemsCount > 10) {
		getMoreBtn.show()
	}
})

// Global const and funcs
const truncateText = (source, size) => {
	return source.length > size ? source.slice(0, size - 1) + '…' : source
}

// Image text CTA
$('.choices__list--dropdown .choices__item').each(function () {
	const $this = $(this)

	if ($this.length > 0) {
		const currentText = $this.text()
		const trimTitle = truncateText(currentText, 10)
		$this.text(trimTitle)
	}
})

$('.nothing-to-show p').click(function () {
	$(this).find('span').toggleText('zobrazit', 'skrýt')
	var id = $(this).attr('id')
	$('#c-' + id).slideToggle()
})

$(document).ready(function () {
	// Configure/customize these variables.
	var showChar = 180 // How many characters are shown by default
	var ellipsestext = '...'
	var moretext = 'Více'
	var lesstext = 'Méně'

	$('.more').each(function () {
		var content = $(this).html()

		if (content.length > showChar) {
			var c = content.substr(0, showChar)
			var h = content.substr(showChar, content.length - showChar)

			var html =
				c +
				'<span class="moreellipses">' +
				ellipsestext +
				'&nbsp;</span><span class="morecontent"><span>' +
				h +
				'</span>&nbsp;&nbsp;<a href="" class="morelink">' +
				moretext +
				'</a></span>'

			$(this).html(html)
		}
	})

	$('.morelink').click(function () {
		if ($(this).hasClass('less')) {
			$(this).removeClass('less')
			$(this).html(moretext)
		} else {
			$(this).addClass('less')
			$(this).html(lesstext)
		}
		$(this).parent().prev().toggle()
		$(this).prev().toggle()
		return false
	})
})

$('.abroad__signpost a').click(function () {
	$('.abroad__signpost a').removeClass('current')
	$(this).closest('a').addClass('current')
})

$('.abroad__signpost a').click(function () {
	$('.abroad__signpost a').removeClass('current')
	$(this).addClass('current')
	$('.abroad__signpost__active').text($(this).text())
})

$('.abroad__signpost__btn').click(function () {
	$('.abroad__signpost__list').slideToggle()
	$(this).toggleClass('btn-rotate')
})

$('#result__sub-content__toggler').click(function () {
	$('.result__sub-content').slideToggle()
})

/* ==========================================================================
    SEARCH LIST
  ========================================================================== */

$('.signpost li').click(function () {
	$('.result__holder').show()
	var id = $(this).attr('id')
	$('.signpost li').removeClass('signpost__item--active')
	$(this).addClass('signpost__item--active')

	$('.result').find('.result__content').hide().removeClass('content-slide-in')
	$('.result')
		.find('div#' + id)
		.show()
		.addClass('content-slide-in')
})

$('.result__content:not(#1)').hide()

/* ==========================================================================
    NEWSLETTER LOGOUT
  ========================================================================== */

$('.news-logout__list li').click(function () {
	var id = $(this).attr('id')
	$('.news-logout__list li').removeClass('news-logout__list--active')
	$(this).addClass('news-logout__list--active')
})

/* ==========================================================================
    WANTED BRIGADES
  ========================================================================== */

$('.w-brigades__block').each(function () {
	var $this = $(this)
	var getToggler = $(this).find('.toggler')
	var $getCount = getToggler.attr('data-count')

	$(getToggler).text('Zobrazit další pozice (' + $getCount + ')')

	$(getToggler).click(function () {
		$(this).toggleText('Zobrazit méně', 'Zobrazit další pozice (' + $getCount + ')')
		$this.find('li.hidden').slideToggle()
	})
})

/* ==========================================================================
    BREADCRUMBS
  ========================================================================== */

hide = true
$('body').on('click', function (e) {
	if (hide) {
		$('.breadcrumbs__item--top').removeClass('show')
		$('.breadcrumbs').removeClass('open')
		$('.container').removeClass('show')
		$('.breadcrumbs__item--menu').removeClass('dropdownShow')
	}
	hide = true
})

$('body').on('click', '.breadcrumbs__item--arrow', function (ee) {
	ee.preventDefault()
	var self = $(this).parents('.breadcrumbs__item--top')
	var breadcrumbsContainer = $(this).parents('.container')
	var breadcrumbsBox = $(this).parents('.breadcrumbs')
	var breadcrumbsItem = $(this).parents('.breadcrumbs__item')

	if (self.hasClass('show')) {
		$('.breadcrumbs__item--top').removeClass('show')
		$(breadcrumbsItem).find('.breadcrumbs__item--menu').removeClass('dropdownShow')
		return false
	}

	$('.breadcrumbs__item--top').removeClass('show')

	self.toggleClass('show')
	breadcrumbsItem.find('.breadcrumbs__item--menu').toggleClass('dropdownShow')
	breadcrumbsContainer.addClass('show')
	breadcrumbsBox.addClass('open')
	hide = false
})

$('body').on('click', '.breadcrumbs-more', function (eee) {
	eee.preventDefault()

	if ($('.breadcrumbs').hasClass('open')) {
		$('.breadcrumbs').removeClass('open')
		$('.container').removeClass('show')
		return false
	}

	$(this).parents('.breadcrumbs').toggleClass('open')
	$(this).parents('.container').toggleClass('show')

	hide = false
})

/* ==========================================================================
	  504
	========================================================================== */
var counter = 17
var interval = setInterval(function () {
	counter--

	if (counter <= 0) {
		clearInterval(interval)
		$('.shutdown__timer').hide()
		$('.shutdown__reload-icon').show()
		$('.shutdown__reload-btn').addClass('shutdown__refresh-enable')
		return
	} else {
		$('.shutdown__time').text(counter)
	}
}, 1000)

/* ==========================================================================
	  	CUSTOM INPUTS - MULTIPLE SELECT
========================================================================== */
$('.multiple-select').multipleSelect({
	formatSelectAll: function () {
		return 'Vybrat vše'
	},
	formatAllSelected: function () {
		return 'Vybráno vše'
	},
	formatCountSelected: function (count, total) {
		return 'Vybráno ' + count + ' z ' + total
	},
})

/* ==========================================================================
	  GLOBAL FORM
========================================================================== */

var maxLength = 600

$('textarea#message').keyup(function () {
	var length = $(this).val().length
	var length = maxLength - length
	$('#chars').text(length)
})

// Přidat email známého
var arrayOfEmails = new Array()

$('.form-group--hidden').each(function () {
	var arrayValue = $(this).attr('data-email-pos')
	arrayOfEmails.push(arrayValue)
})

let addEmailCounter = 0

$('#add-another-email').click(function () {
	addEmailCounter++

	$(".form-group--hidden[data-email-pos='" + addEmailCounter + "']").show()

	$('#add-another-email span').text(arrayOfEmails.length - addEmailCounter)

	if (addEmailCounter === arrayOfEmails.length) {
		$(this).hide()
	}
})

/* ==========================================================================
	 	NON ACTIVE AD
========================================================================== */

$('.ad-detail__banner__more').click(function () {
	$(this).find('span').toggleClass('rotate')
	$('.non-active-content').slideToggle()
})

/* ==========================================================================
	  LOGIN PAGE
========================================================================== */

$('#login-as-customer').click(function () {
	$('.login-page-type-form').slideToggle()
})

/* ==========================================================================
	  FAJN SOUTĚŽ
========================================================================== */

const scrollToElement = (target, speed) => {
	$('html, body').animate(
		{
			scrollTop: $(target).offset().top,
		},
		speed,
	)
}

$('#submit-compete-button').click(function (e) {
	e.preventDefault()
	$('#prices-dialog-part-one').hide()
	$('#prices-dialog-part-two').show()
})

$('#want-trip-button').click(function () {
	parent.jQuery.fancybox.close()
})

$('.competition__select-bg div').click(function () {
	// $(".competition__error--select-bg").hide();
	$('.selected-image').hide()
	$('.competition__generated').html('').removeClass('opacity').addClass('opacity')
	$(this).addClass('selected').siblings().removeClass('selected')
	$(this).find('img').clone().appendTo('.competition__generated')
})

$('#create-thumbnail').click(function (e) {
	e.preventDefault()

	if ($('.competition__generated').is(':empty')) {
		$('.competition__error--select-bg').show()
		scrollToElement('.competition__error--select-bg', 500)
	} else {
		$('.selected-image').show()
	}
})

const shareData = {
	title: 'MDN',
	text: 'Learn web development on MDN!',
	url: 'https://developer.mozilla.org',
}

const shareBtn = document.querySelector('.share-btn')
const shareResult = document.querySelector('.share-result')

// Share must be triggered by "user activation"
if (shareBtn !== null) {
	shareBtn.addEventListener('click', async () => {
		try {
			await navigator.share(shareData)
			shareResult.textContent = 'Úspěšně nasdíleno'
		} catch (err) {
			shareResult.textContent = `Error: ${err}`
		}
	})
}

/* ==========================================================================
	  CUSTOM INPUTS -AWESOMPLETE (NAŠEPTÁVAČ)
========================================================================== */
var input = document.getElementById('input-52')

if (typeof input != 'undefined' && input != null) {
	new Awesomplete(input, { list: '#vehiclesList' })
}

var input2 = document.getElementById('input-53')

if (typeof input2 != 'undefined' && input2 != null) {
	new Awesomplete(input2, {
		list: ['Ada', 'Java', 'JavaScript', 'Brainfuck', 'LOLCODE', 'Node.js', 'Ruby on Rails'],
	})
}

/* ==========================================================================
	  CUSTOM INPUTS - TOOLTIP
========================================================================== 

tippy('span.tippy-help', {
	content(reference) {
		const id = reference.getAttribute('data-template')
		const template = document.getElementById(id)
		return template.innerHTML
	},
	allowHTML: true,
}) */

// Zdroj: https://bbbootstrap.com/snippets/multiselect-dropdown-list-83601849
// Nastavení: https://github.com/Choices-js/Choices
/* 
var multipleCancelButton = new Choices('#category-select', {
	removeItemButton: true,
	maxItemCount: 5,
	searchResultLimit: 15,
	renderChoiceLimit: 15,
	itemSelectText: 'Vybrat',
	maxItemText: 'Vyčerpán maximální počet položek',
	noResultsText: 'Nenalezeno',
	placeholderValue: 'Kategorie',
	searchPlaceholderValue: 'Vyberte jednu z možností',
	noChoicesText: 'Nic dalšího k vybrání',
})

var multipleCancelButton = new Choices('#suitable-for-select', {
	removeItemButton: true,
	maxItemCount: 10,
	searchResultLimit: 15,
	renderChoiceLimit: 15,
	itemSelectText: 'Vybrat',
	maxItemText: 'Vyčerpán maximální počet položek',
	noResultsText: 'Nenalezeno',
	placeholderValue: 'Vhodné pro',
	searchPlaceholderValue: 'Vyberte jednu z možností',
	noChoicesText: 'Nic dalšího k vybrání',
})

var multipleCancelButton = new Choices('#vip-select', {
	removeItemButton: true,
	maxItemCount: 10,
	searchResultLimit: 15,
	renderChoiceLimit: 15,
	itemSelectText: 'Vybrat',
	maxItemText: 'Vyčerpán maximální počet položek',
	noResultsText: 'Nenalezeno',
	placeholderValue: 'VIP firmy',
	searchPlaceholderValue: 'Vyberte jednu z možností',
	noChoicesText: 'Nic dalšího k vybrání',
})

var multipleCancelButton = new Choices('#benefits', {
	removeItemButton: true,
	maxItemCount: 10,
	searchResultLimit: 15,
	renderChoiceLimit: 15,
	itemSelectText: 'Vybrat',
	maxItemText: 'Vyčerpán maximální počet položek',
	noResultsText: 'Nenalezeno',
	placeholderValue: 'Benefity',
	searchPlaceholderValue: 'Vyberte jednu z možností',
	noChoicesText: 'Nic dalšího k vybrání',
})

var multipleCancelButton = new Choices('#positions', {
	removeItemButton: true,
	maxItemCount: 10,
	searchResultLimit: 15,
	renderChoiceLimit: 15,
	itemSelectText: 'Vybrat',
	maxItemText: 'Vyčerpán maximální počet položek',
	noResultsText: 'Nenalezeno',
	placeholderValue: 'Pozice',
	searchPlaceholderValue: 'Vyberte jednu z možností',
	noChoicesText: 'Nic dalšího k vybrání',
})

var multipleCancelButton = new Choices('#another', {
	removeItemButton: true,
	maxItemCount: 10,
	searchResultLimit: 15,
	renderChoiceLimit: 15,
	itemSelectText: 'Vybrat',
	maxItemText: 'Vyčerpán maximální počet položek',
	noResultsText: 'Nenalezeno',
	placeholderValue: 'Další',
	searchPlaceholderValue: 'Vyberte jednu z možností',
	noChoicesText: 'Nic dalšího k vybrání',
})

/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/

;('use strict')
;(function (document, window, index) {
	var inputs = document.querySelectorAll('.inputfile')
	Array.prototype.forEach.call(inputs, function (input) {
		var label = input.nextElementSibling,
			labelVal = label.innerHTML

		input.addEventListener('change', function (e) {
			var fileName = ''
			if (this.files && this.files.length > 1) fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length)
			else fileName = e.target.value.split('\\').pop()

			if (fileName) label.querySelector('span').innerHTML = fileName
			else label.innerHTML = labelVal
		})

		// Firefox bug fix
		input.addEventListener('focus', function () {
			input.classList.add('has-focus')
		})
		input.addEventListener('blur', function () {
			input.classList.remove('has-focus')
		})
	})
})(document, window, 0)
